export default __webpack_public_path__ + "static/media/ico-rewards-01.c831c716.svg";